import { App } from 'ovee.js';
import OveeBarba from '@ovee.js/barba';
import { ContentLoader } from '@ovee.js/content-loader';
import { isIOS, isAndroid } from '@/tools/browser';
import InViewport from './components/InViewport';
import SliderMain from './components/SliderMain';
import NavToggle from './components/NavToggle';
import NavCount from './components/NavCount'; // import CollapsingHeader from './components/CollapsingHeader';
// import StickyNav from './components/StickyNav';

import LazyLoad from './components/LazyLoad'; // import SliderFocus from './components/SliderFocus';
// import SliderGrid from './components/SliderGrid';

import SliderRoom from './components/SliderRoom'; // import SliderTone from './components/SliderTone';

import VideoAutoplay from './components/VideoAutoplay';
import BaseSelect from './components/BaseSelect';
import DatePicker from './components/DatePicker';
import DropdownList from './components/DropdownList';
import PlayerVimeo from './components/PlayerVimeo';
import PlayerYouTube from './components/PlayerYouTube';
import CopyLink from './components/CopyLink';
import ModalBase from './components/ModalBase';
import ModalTrigger from './components/ModalTrigger';
import SliderModalGallery from './components/SliderModalGallery'; // import FilterBar from './components/FilterBar';

import LoadMore from './components/LoadMore';
import AccordionBase from './components/AccordionBase'; // import AccordionFilter from './components/AccordionFilter';
// import AccordionBlockList from './components/AccordionBlockList';
// import AccordionContact from './components/AccordionContact';
// import AccordionTeam from './components/AccordionTeam';

import AccordionForm from './components/AccordionForm';
import FormBase from './components/FormBase';
import CookiesPopup from './components/CookiesPopup';
import GoogleMap from './components/map/GoogleMap';
import SourceLink from './components/SourceLink';
import BackLink from './components/BackLink';
import ResetLinkStash from './components/ResetLinkStash';
import PageChat from './components/PageChat'; // import Masonry from './components/Masonry';
// import LoadMoreGallery from './components/LoadMoreGallery';
// import SliderGalleryPopup from './components/SliderGalleryPopup';

import AudioToggle from './components/AudioToggle';
import FloorPlan from './components/FloorPlan';
import DownloadLink from './components/DownloadLink';
import StaticDialog from './components/StaticDialog'; // import LiveSearch from './components/LiveSearch';
// import TabSwitcher from './components/TabSwitcher';

import ResizeX from './modules/ResizeX';
import Fix100vh from './modules/Fix100vh';
import DownloadTrap from './modules/DownloadTrap';
import LoadMoreResolver from './resolvers/LoadMoreResolver'; // import FilterBarResolver from './resolvers/FilterBarResolver';
// import SearchResolver from './resolvers/SearchResolver';

import defaultTransition from './transitions/default';
import modalEnterTransition from './transitions/modalEnter';
import modalExitTransition from './transitions/modalExit';
var root = document.body;
var app = new App({
  config: {
    baseUrl: root.dataset.baseHref
  },
  components: [InViewport, SliderMain, LazyLoad, SliderRoom, VideoAutoplay, BaseSelect, DatePicker, DropdownList, PlayerVimeo, PlayerYouTube, CopyLink, ModalBase, ModalTrigger, SliderModalGallery, LoadMore, AccordionBase, AccordionForm, FormBase, CookiesPopup, GoogleMap, SourceLink, BackLink, ResetLinkStash, PageChat, AudioToggle, FloorPlan, DownloadLink, StaticDialog, NavToggle, NavCount]
});
app.use(OveeBarba, {
  transitions: [defaultTransition, modalEnterTransition, modalExitTransition],
  timeout: 60000,
  preventRunning: true,
  usePrefetch: isIOS() && !isAndroid(),
  hooks: {
    after: function after() {
      if (global.dataLayer !== undefined) {
        try {
          global.dataLayer.push({
            event: 'content-view',
            'content-name': global.location.pathname
          }); // eslint-disable-next-line no-empty
        } catch (e) {}
      }
    }
  }
});
app.use(ResizeX);
app.use(Fix100vh);
app.use(DownloadTrap);
app.use(ContentLoader, {
  timeout: 500000,
  resolvers: {
    'load-more': LoadMoreResolver
  }
});
app.run(root);